import builder from '../builder';
import VideoPlayerAdjust from '../../streamline-icons/light/video-player-adjust.svg';

export default builder('IconVideoPlayerAdjustLight', VideoPlayerAdjust);
